import http from '@/http'
const URL = '/admin/video-categories'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const save = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const destroy = async (id) => http.delete(URL + `/${id}`)

export default {
  list,
  show,
  save,
  destroy
}
